<app-headersecond></app-headersecond>
<section class="section banner">
  <div class="container">
      <div class="section-box-banner">
              <div>
                <h3>Editar</h3><h2> Persona</h2>
                <form [formGroup]="itemForm" (ngSubmit)="saveItem()">
                  <div>
                    <h1><label for="nombre">Nombre:</label>
                    <input type="text" class="custom-textarea" id="nombre" maxlength="20" placeholder="Nombre" formControlName="nombre" /></h1>
                    <div *ngIf="itemForm.controls['nombre'].invalid && (itemForm.controls['nombre'].dirty || itemForm.controls['nombre'].touched)" class="text-danger">
                      <div *ngIf="itemForm.controls['nombre'].errors.required">El campo Nombre es obligatorio.</div>
                      <div *ngIf="itemForm.controls['nombre'].errors.minlength">El Nombre debe tener al menos 3 caracteres.</div>
                    </div>
                  </div>
                  <div>
                    <h1><label for="apellido">Apellido:</label>
                    <input type="text" class="custom-textarea"  id="apellido" maxlength="20" placeholder="Apellido" formControlName="apellido" /></h1>
                    <div *ngIf="itemForm.controls['apellido'].invalid && (itemForm.controls['apellido'].dirty || itemForm.controls['apellido'].touched)" class="text-danger">
                      <div *ngIf="itemForm.controls['apellido'].errors.required">El campo Apellido es obligatorio.</div>
                      <div *ngIf="itemForm.controls['apellido'].errors.minlength">El Apellido debe tener al menos 4 caracteres.</div>
                    </div>
                  </div>
                  <div>
                    <h1><label for="descripcion">Descripción:</label>
                    <input class="custom-textarea"  maxlength="80" type="text" id="descripcion" placeholder="Descripción" formControlName="descripcion" /></h1>
                    <div *ngIf="itemForm.controls['descripcion'].invalid && (itemForm.controls['descripcion'].dirty || itemForm.controls['descripcion'].touched)" class="text-danger">
                      <div *ngIf="itemForm.controls['descripcion'].errors.required">El campo Descripción es obligatorio.</div>
                      <div *ngIf="itemForm.controls['descripcion'].errors.minlength">La Descripción debe tener al menos 5 caracteres.</div>
                    </div>
                  </div>
                  <button class="main-btn" type="submit" [disabled]="itemForm.invalid" [ngClass]="{ 'disabled-button': itemForm.invalid }">Guardar cambios</button>
                </form>
              </div>
            </div>
          </div>
      
</section>